import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import FloatingIcons from "./FloatingIcons";

export default function FinalCTA() {
    return (
        <section
            id="contact"
            data-testid="final-cta-section"
            className="relative text-white py-24 lg:py-32 overflow-hidden"
            style={{ backgroundColor: "#0d3a6e" }}
        >
            {/* subtle blue glow */}
            <div
                aria-hidden
                className="absolute -top-32 left-1/2 -translate-x-1/2 h-[600px] w-[1200px] rounded-full blur-[120px] opacity-30"
                style={{ background: "radial-gradient(closest-side, #0F3D7A, transparent)" }}
            />

            {/* floating doodle icons */}
            <FloatingIcons tone="dark" />

            <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                    className="font-display tracking-[-0.05em] leading-[0.85] text-[7.5vw] sm:text-[6vw] lg:text-[5.75rem] font-bold"
                >
                    <span className="block uppercase text-white">LET'S CREATE A</span>
                    <span className="block uppercase" style={{ color: "#9ca3af" }}>BUZZ</span>
                </motion.h2>

                <div className="mt-16 grid lg:grid-cols-12 gap-12">
                    {/* Left meta */}
                    <div className="lg:col-span-5 flex flex-col gap-10">
                        <p className="text-sm text-white/60 max-w-md leading-relaxed">
                            Tell us about your brand and what you are trying to grow. We
                            reply to every enquiry within 24 hours — usually faster.
                        </p>
                        <div className="grid grid-cols-2 gap-8">
                            <div>
                                <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                                    Email
                                </p>
                                <a
                                href="tel:+917987924110"
                                    className="mt-2 block text-base text-white hover:text-communiti-soft break-all"
                                >
                                    commmmuniti@gmail.com
                                </a>
                            </div>
                            <div>
                                <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                                    Phone Number
                                </p>
                                <a
                                    href="tel:+917987924110"
                                    className="mt-2 block text-base text-white hover:text-communiti-soft"
                                >
                                    +91 7987924110
                                </a>
                            </div>
                            <div className="col-span-2">
                                <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                                    Indore
                                </p>
                                <p className="mt-2 text-base text-white leading-relaxed">
                                    6, Manik Bagh Road, Near Navgrah Mandir, Roop Ram Nagar, Indore, Madhya Pradesh 452007, India
                                </p>
                            </div>
                            <div>
                                <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                                    Hours
                                </p>
                                <p className="mt-2 block text-base text-white">Mon - Fri ~ 11 to 7</p>
                            </div>
                        </div>

                        <div className="mt-4">
                            <a
                                href="mailto:commmmuniti@gmail.com"
                                className="group inline-flex items-center gap-2 rounded-full bg-communiti text-white pl-6 pr-2 py-2.5 text-sm font-medium hover:bg-white hover:text-black transition-colors"
                            >
                                Start Your Project
                                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-black group-hover:rotate-45 transition-transform duration-300">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </a>
                        </div>
                    </div>

                    {/* Right column: CTA */}
                    <div className="lg:col-span-7 flex flex-col gap-6">
                        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8">
                            <p className="font-display text-2xl font-bold text-white mb-3">
                                Ready to scale?
                            </p>
                            <p className="text-sm text-white/60 leading-relaxed mb-6">
                                Book a free 30-minute strategy call. We will audit your brand,
                                identify quick wins, and map a 90-day growth plan — no
                                obligation.
                            </p>
                            <a
                                href="tel:+917987924110"
                                className="group inline-flex items-center gap-2 rounded-full bg-white text-black pl-6 pr-2 py-2.5 text-sm font-medium hover:bg-communiti hover:text-white transition-colors"
                            >
                                Book Free Call
                                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-black text-white group-hover:rotate-45 transition-transform duration-300">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
